import React from 'react';

function CustomerJourney(props) {
  return (
    <svg height={24} width={24} xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M8 2.375H16C16.9317 2.375 17.625 3.24164 17.625 4.25V20.55C17.625 21.2134 17.1557 21.8 16.4949 21.8C16.2396 21.7979 15.9965 21.702 15.8018 21.532L11.999 18.205L8.19794 21.5323C7.6955 21.9714 6.9861 21.8497 6.61589 21.3259L6.54653 21.2158C6.4333 21.0154 6.375 20.7845 6.375 20.55V4.25C6.375 3.24164 7.06831 2.375 8 2.375ZM16.0582 3.6342L16 3.625H8C7.82769 3.625 7.625 3.87836 7.625 4.25V20.372L11.5884 16.9046C11.7979 16.7214 12.0992 16.701 12.329 16.8435L12.4116 16.9046L16.375 20.372V4.25C16.375 3.91965 16.2149 3.68276 16.0582 3.6342Z"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default CustomerJourney;
